
var contextmenu = {
    toggleActive: function($item, isActive) {
        if (isActive) {
            $item.removeClass('disabled');
            $item.find('.dropdown-item').removeClass('disabled');
        } else {
            $item.addClass('disabled');
            $item.find('.dropdown-item').addClass('disabled');
        }
    }
};
window.contextmenu = contextmenu;

function contextMenuClickDelegate($menu, $menuTarget, targetEl, event) {
    $menuTarget.data('menu.node', targetEl);
    $(document).bind("keydown.slidein-box", function(event) {
        if (event.which === $.ui.keyCode.ESCAPE) {
            closeFilesMenu($menu, $menuTarget);
        }
    }).bind("mousedown.slidein-box", function(event) {
        // Close menu when clicked outside menu
        if($(event.target).closest(".ui-menu-item").length === 0) {
            closeFilesMenu($menu, $menuTarget);
        }
    });

    $menu.trigger('open', [$menu, targetEl]);
    targetEl.addClass('context-open');
    $menu
        .css("position", "absolute")
        .css('width', 'auto')
        .show()
        .position( { my: ($(event.currentTarget).attr('data-contextmenu-my') || "left top"), at: ($(event.currentTarget).attr('data-contextmenu-at') || "right top"), of: event.originalEvent, collision: "flipfit" } );
    $menu.focus();
}

function closeFilesMenu($menu, $menuTarget) {
    $(document).unbind("keydown.slidein-box, mousedown.slidein-box");
    $menuTarget.find('.context-open').removeClass('context-open');
    $menu.hide();
    $menuTarget.data('menu.node', null);
}
window.closeFilesMenu = closeFilesMenu;

$(document).on('content-ready', function(ev, container) {
    container.find('[data-contextmenu-click]').click(function(event) {
        event.stopPropagation();
        var me = $(this);
        var targetEl = me.closest(me.attr('data-contextmenu-click'));
        var $menu = $(me.attr('data-contexttarget'));
        var $menuTarget = $('[data-contextmenu="#'+$menu.attr('id')+'"]');
        contextMenuClickDelegate($menu, $menuTarget, targetEl, event);
        return false;
    });

    var $menus = container.find('[data-contextmenu]');
    $.each($menus, function() {
        var $menuTarget = $(this);
        var $menu = $($menuTarget.attr('data-contextmenu'));

        if ($menu) {
            $menu.menu({
                select: function(event, ui) {
                    event.preventDefault();
                    var contextItem = ui.item.find(">a");
                    if (ui.item.is('.disabled') || ui.item.is('.no-action') || ui.item.is('.dropdown-submenu')) return;
                    //
                    var action = contextItem.attr("href");
                    var node = $menuTarget.data('menu.node');
                    var result = $menu.trigger('selected.' + action.replace('#', ''), [node, contextItem]);
                    if (result !== false) {
                        closeFilesMenu($menu, $menuTarget);
                    }
                }
            }).hide();

            $menuTarget.delegate($menuTarget.attr('data-delegates'), "contextmenu", function(event) {
                var targetEl = $(this);
                contextMenuClickDelegate($menu, $menuTarget, targetEl, event);
                return false;
            });
        }
    });
});
